var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Link } from "react-router-dom";
import HeaderStart from "./headerStart";
import HeaderEnd from "./headerEnd";
import HeaderCenter from "./headerCenter";
import ProfileMenu from "@/components/session/ProfileMenu";
import { ETCRM_URL } from "@/utils/const";
import { useTranslation } from "react-i18next";
export function HeaderLarge(_a) {
    var data = _a.data;
    var t = useTranslation(["common"]).t;
    return (_jsxs("div", __assign({ className: "flex flex-row items-stretch flex-auto h-[var(--sizes-header-height)]" }, { children: [_jsx("div", __assign({ className: "navbar-brand flex flex-none w-[16rem] justify-center items-center cursor-pointer bg-[var(--colors-header-logo)]" }, { children: _jsx(Link, __assign({ to: "/" }, { children: _jsx("img", { src: "".concat(ETCRM_URL, "/").concat(data === null || data === void 0 ? void 0 : data.logo), alt: t("app.LBL_COMPANY_LOGO", { ns: "common" }) }) })) })), _jsxs("div", __assign({ className: "z-10 flex flex-row flex-auto h-full overflow-auto bg-[var(--colors-header)]" }, { children: [_jsx(HeaderStart, {}), _jsx(HeaderCenter, {}), _jsx(HeaderEnd, {})] })), _jsx("div", __assign({ className: "flex items-center justify-center flex-none cursor-pointer navbar-brand bg-[var(--colors-header-user)]" }, { children: _jsx(ProfileMenu, {}) }))] })));
}
